import React, { Component } from "react"
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'

import Spacer from '~/components/Spacer'
import CheckImage from '~/components/svg/GreenCheckCircle'
import DesktopContainer from '~/components/DesktopContainer'
import Hand from "../../../public/static/images/png/hand.png"
import Divider from "~/components/traffic-tickets/steps/Divider"

const ImageBackground = styled.div`
  background-repeat: no-repeat;
  background-position: left top 9%;
  background-size: 170px 260px;
  background-image: url(${Hand});
`

const SuccessText = styled.div`
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  font-size: 1.125rem;
  text-align: center;
`

const TitleWraper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const PaymentAccepted = styled.div`
  font-family: ${props => props.theme.fonts.avenirNextHeavy};
  font-size: 2.375em;
  display: flex;
  text-align:center;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
`

const SubText = styled.div`
  color: ${props => props.theme.colors.text.label};
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  line-height: 1.4375rem;
  font-size: 1.25rem;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  max-width: 690px;
  ${props => props.theme.media.smallDesktop`
      max-width: 500px;
  `}
  ${props => props.theme.media.mobile`
      max-width: 200px;
  `}
  width: 100%;
`
const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 340px;
  flex-shrink: 1;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 9px 24px rgba(0, 0, 0, 0.1);
  ${props => props.theme.media.smallDesktop`
    margin-top: 25px;
  `}
  ${props => props.theme.media.mobile`
    width: 100%;
  `}
`

const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

const ItemName = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  color: ${props => props.theme.colors.text.label};
  font-size: 1.125em;
`
const ItemAmount = styled.div`
  font-family: ${props => props.theme.fonts.avenirNextBold};
  color: ${props => props.theme.colors.text.label};
  font-size: 1.125em;
`

const SubtotalAmount = styled.div`
  font-family: ${props => props.theme.fonts.avenirNextDemi};
  color: ${props => props.theme.colors.success};
  font-size: 1.7em;
`

const AmountBreakdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 1em;
  padding-top: 1.5em;
`
@inject(all => ({
  isMobile: all.store.ui.isMobile,
  tickets:all.store.parkingFlow.results.paySelected,
  totalSelectedPayableAmount: all.store.parkingFlow.results.totalSelectedPayableAmount,
  feeForSelectedPayable: all.store.parkingFlow.results.feeForSelectedPayable,
  totalServiceFee: all.store.parkingFlow.results.totalServiceFee,
  paySubtotal: all.store.parkingFlow.results.paySubtotal
}))
@observer
class PaySuccess extends Component {

  render() {
    const listTickets = this.props.tickets.map((ticket) =>
      <div key={ticket.ticketID}>#{ticket.ticketID}</div>
    );
    return (
      <DesktopContainer>
        <ImageBackground>
          <Spacer mobile={30} desktop={56} />
          <TitleWraper>
            <Spacer mobile={10} desktop={6} />
            <PaymentAccepted>
              PAYMENT ACCEPTED
              <Spacer mobile={2} desktop={5} direction="width" />
              <CheckImage size={33} />
              <Spacer mobile={2} desktop={5} direction="width" />
              <SuccessText>
                Success
              </SuccessText>
            </PaymentAccepted>
            <Spacer mobile={15} desktop={29} />
            <SubText>
              We will process your payment on your behalf within 1 business day.
            </SubText>
            <Spacer mobile={15} desktop={29} />
            <CardContainer>
              <AmountBreakdownContainer>
                <div>
                  <ItemName><b>ORDER SUMMARY</b></ItemName>
                </div>
                <Divider top={16} bottom={16} />
                <InfoRow>
                  <ItemName>Tickets</ItemName>
                  <i>{listTickets}</i>
                  <ItemAmount>${this.props.totalSelectedPayableAmount.toFixed(2)}</ItemAmount>
                </InfoRow>
                <Divider top={16} bottom={16} />
                <InfoRow>
                  <ItemName>
                    Service Fee
                  </ItemName>
                  <ItemAmount>${this.props.totalServiceFee.toFixed(2)}</ItemAmount>
                </InfoRow>
                <Divider top={16} bottom={16} />
                <InfoRow>
                  <ItemName>
                    Processing Fee
                  </ItemName>
                  <ItemAmount>${this.props.feeForSelectedPayable.toFixed(2)}</ItemAmount>
                </InfoRow>
                <Divider top={16} bottom={0} />
                <Spacer mobile={10} desktop={10} />
                <InfoRow>
                  <ItemName><b>Total</b></ItemName>
                  <SubtotalAmount>${this.props.paySubtotal.toFixed(2)}</SubtotalAmount>
                </InfoRow>
              </AmountBreakdownContainer>
            </CardContainer>
          </TitleWraper>
        </ImageBackground>
      </DesktopContainer>
  )
  }
}

export default PaySuccess
